/*
frame icons should only be used from 'gds-section-header' and 'gds-page-header',
these default variable values are set and those components provide overrides
when the icontype is prefixed with 'frame-'
*/

.geico-icon {
  font-family: "geico";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-vehicle:before,
.icon-frame-vehicle:before {
  content: var(--vehicle-icon, "\e100");
}

.icon-vehicle-multi:before {
  content: "\e101";
}

.icon-motorcycle:before,
.icon-frame-motorcycle:before {
  content: var(--motorcycle-icon, "\e102");
}

.icon-motorcycle-multi:before {
  content: "\e103";
}

.icon-atv:before,
.icon-frame-atv:before {
  content: var(--atv-icon, "\e104");
}

.icon-atv-ins:before {
  content: "\e104";
}

.icon-rv:before,
.icon-frame-rv:before {
  content: var(--rv-icon, "\e105");
}

.icon-rv-ins:before {
  content: "\e105";
}

.icon-boat:before,
.icon-frame-boat:before {
  content: var(--boat-icon, "\e106");
}

.icon-boat-ins:before {
  content: "\e106";
}

.icon-commercial-ins:before {
  content: "\e107";
}

.icon-auto-collector-ins:before {
  content: "\e108";
}

.icon-homeowner:before,
.icon-frame-homeowner:before {
  content: var(--homeowner-icon, "\e109");
}

.icon-homeowner-ins:before {
  content: "\e109";
}

.icon-renters-ins:before {
  content: "\e110";
}

.icon-condo:before,
.icon-frame-condo:before {
  content: var(--condo-icon, "\e111");
}

.icon-condo-ins:before {
  content: "\e111";
}

.icon-mobile-home-ins:before {
  content: "\e112";
}

.icon-flood-ins:before {
  content: "\e113";
}

.icon-umbrella-ins:before {
  content: "\e114";
}

.icon-life-ins:before {
  content: "\e115";
}

.icon-web:before {
  content: "\e116";
}

.icon-id-protection-ins:before {
  content: "\e117";
}

.icon-collectibles:before,
.icon-frame-collectibles:before {
  content: var(--collectibles-icon, "\e118");
}

.icon-collectibles-ins:before {
  content: "\e118";
}

.icon-business-ins:before {
  content: "\e119";
}

.icon-pet:before,
.icon-frame-pet:before {
  content: var(--pet-icon, "\e120");
}

.icon-pet-ins:before {
  content: "\e120";
}

.icon-rental-car-ins:before {
  content: "\e121";
}

.icon-dwelling-fire:before {
  content: "\e122";
}

.icon-animal-claim:before {
  content: "\e123";
}

.icon-profile:before {
  content: "\e124";
}

.icon-profile-multi:before {
  content: "\e125";
}

.icon-motorcycle-rider:before {
  content: "\e126";
}

.icon-motorcycle-rider-multi:before {
  content: "\e127";
}

.icon-policy:before {
  content: "\e128";
}

.icon-policies:before {
  content: "\e129";
}

.icon-id-card:before {
  content: "\e130";
}

.icon-id-cards:before {
  content: "\e131";
}

.icon-license:before {
  content: "\e132";
}

.icon-documents:before {
  content: "\e133";
}

.icon-address:before {
  content: "\e134";
}

.icon-coverage:before {
  content: "\e135";
}

.icon-coverage-added:before {
  content: "\e136";
}

.icon-account-info:before {
  content: "\e137";
}

.icon-policy-review:before {
  content: "\e138";
}

.icon-e-signature:before {
  content: "\e139";
}

.icon-medical:before {
  content: "\e140";
}

.icon-resource-center:before {
  content: "\e141";
}

.icon-alert:before {
  content: "\e142";
}

.icon-info:before {
  content: "\e143";
}

.icon-notifications:before {
  content: "\e144";
}

.icon-non-critical-warning:before {
  content: "\e145";
}

.icon-tips:before {
  content: "\e146";
}

.icon-settings:before {
  content: "\e147";
}

.icon-bill:before {
  content: "\e148";
}

.icon-quotes:before {
  content: "\e149";
}

.icon-bills:before {
  content: "\e150";
}

.icon-current-discount:before {
  content: "\e151";
}

.icon-credit-card:before {
  content: "\e152";
}

.icon-credit-card-multi:before {
  content: "\e153";
}

.icon-check:before {
  content: "\e154";
}

.icon-cash:before {
  content: "\e155";
}

.icon-billing-details:before {
  content: "\e156";
}

.icon-paperless:before {
  content: "\e157";
}

.icon-confirmation:before,
.icon-check-mark:before {
  content: "\e158";
}

.icon-question-mark:before {
  content: "\e159";
}

.icon-contact:before {
  content: "\e160";
}

.icon-email:before {
  content: "\e161";
}

.icon-sms-feedback:before {
  content: "\e162";
}

.icon-calendar:before {
  content: "\e163";
}

.icon-help-center-agent:before {
  content: "\e164";
}

.icon-call:before {
  content: "\e165";
}

.icon-fax:before {
  content: "\e166";
}

.icon-print:before {
  content: "\e167";
}

.icon-mail:before {
  content: "\e168";
}

.icon-geolocation:before {
  content: "\e169";
}

.icon-edit:before {
  content: "\e170";
}

.icon-navigation-arrow:before {
  content: "\e171";
}

.icon-roadside-assist:before {
  content: "\e172";
}

.icon-ers:before {
  content: "\e173";
}

.icon-accident-assist:before {
  content: "\e174";
}

.icon-breakdown:before {
  content: "\e175";
}

.icon-vandalism:before {
  content: "\e176";
}

.icon-accident:before {
  content: "\e177";
}

.icon-hit-rental-car:before {
  content: "\e178";
}

.icon-collision:before {
  content: "\e179";
}

.icon-glass:before {
  content: "\e180";
}

.icon-gas-station:before {
  content: "\e181";
}

.icon-repair-shop:before {
  content: "\e182";
}

.icon-inspection:before {
  content: "\e183";
}

.icon-claims:before {
  content: "\e184";
}

.icon-cab:before {
  content: "\e185";
}

.icon-locksmith:before {
  content: "\e186";
}

.icon-weather:before {
  content: "\e187";
}

.icon-security:before {
  content: "\e188";
}

.icon-faq:before {
  content: "\e189";
}

.icon-extras:before {
  content: "\e190";
}

.icon-customer-review:before {
  content: "\e191";
}

.icon-local-agent:before {
  content: "\e192";
}

.icon-gfr-geico:before {
  content: "\e193";
}

.icon-legal:before {
  content: "\e194";
}

.icon-video:before {
  content: "\e195";
}

.icon-launch-ios:before {
  content: "\e196";
}

.icon-launch-android:before {
  content: "\e197";
}

.icon-loader-g:before {
  content: "\e198";
}

.icon-geico:before,
.icon-frame-geico:before {
  content: var(--geico-icon, "\e198");
}

.icon-share-ios:before {
  content: "\e199";
}

.icon-share-android:before {
  content: "\e200";
}

.icon-menu:before {
  content: "\e201";
}

.icon-search:before {
  content: var(--search-icon, "\e202");
}

.icon-feedback:before {
  content: "\e203";
}

.icon-quick-link:before {
  content: "\e204";
}

.icon-arrow:before {
  content: "\e205";
}

.icon-turn:before {
  content: "\e206";
}

.icon-lilly:before,
.icon-g-microphone:before {
  content: "\e207";
}

.icon-expand:before {
  content: "\e208";
}

.icon-collapse:before {
  content: "\e209";
}

.icon-close:before {
  content: "\e210";
}

.icon-chevron-rating:before {
  content: "\e211";
}

.icon-chevron-right:before {
  content: "\e212";
}

.icon-chevron-left:before {
  content: "\e213";
}

.icon-chevron-down:before {
  content: "\e214";
}

.icon-chevron-up:before {
  content: "\e215";
}

.icon-chevron-unsorted:before {
  content: "\e216";
}

.icon-chevron-double-right:before {
  content: "\e217";
}

.icon-chevron-double-left:before {
  content: "\e218";
}

.icon-chevron-link:before {
  content: "\e219";
}

.icon-info-i:before {
  content: "\e220";
}

.icon-calendar-button:before {
  content: "\e221";
}

.icon-rating-button:before {
  content: "\e222";
}

.icon-help-button:before {
  content: "\e223";
}

.icon-facebook:before {
  content: "\e224";
}

.icon-google:before {
  content: "\e225";
}

.icon-twitter:before {
  content: "\e226";
}

.icon-youtube:before {
  content: "\e227";
}

.icon-benefits:before {
  content: "\e228";
}

.icon-due-date:before {
  content: "\e229";
}

.icon-smartphone:before {
  content: "\e230";
}

.icon-go-green:before {
  content: "\e231";
}

.icon-safety-info:before {
  content: "\e232";
}

.icon-cycle-safety:before {
  content: "\e233";
}

.icon-proof-insurance:before {
  content: "\e234";
}

.icon-refresh:before {
  content: "\e235";
}

.icon-license-plate:before {
  content: "\e236";
}

.icon-geico:before {
  content: "\e237";
}

.icon-add-vehicle:before {
  content: "\e238";
}

.icon-add-driver:before {
  content: "\e239";
}

.icon-add-motorcycle:before {
  content: "\e240";
}

.icon-mouse:before {
  content: "\e241";
}

.icon-apple:before {
  content: "\e242";
}

.icon-android:before {
  content: "\e243";
}

.icon-vehicle-inspection:before {
  content: "\e244";
}

.icon-repair-location:before {
  content: "\e245";
}

.icon-report-claim:before {
  content: "\e246";
}

.icon-about-claims:before {
  content: "\e247";
}

.icon-careers:before {
  content: "\e248";
}

.icon-b2b:before {
  content: "\e249";
}

.icon-life-plan:before {
  content: "\e250";
}

.icon-federal-employee:before {
  content: "\e251";
}

.icon-military-personnel:before {
  content: "\e252";
}

.icon-geico-affiliate:before {
  content: "\e253";
}

.icon-catastrophe-center:before {
  content: "\e254";
}

.icon-overseas-ins:before {
  content: "\e255";
}

.icon-state-guidelines:before {
  content: "\e256";
}

.icon-publication:before {
  content: "\e257";
}

.icon-merchandise:before {
  content: "\e258";
}

.icon-commercial:before {
  content: "\e259";
}

.icon-press-release:before {
  content: "\e260";
}

.icon-share:before {
  content: "\e261";
}

.icon-linkedin:before {
  content: "\e262";
}

.icon-instagram:before {
  content: "\e263";
}

.icon-pinterest:before {
  content: "\e264";
}

.icon-loss-of-use:before {
  content: "\e265";
}

.icon-non-building-structure:before {
  content: "\e266";
}

.icon-other-structures:before {
  content: "\e267";
}

.icon-special-personal-property:before {
  content: "\e268";
}

.icon-water-backup:before {
  content: "\e269";
}

.icon-snowmobile:before {
  content: "\e270";
}

.icon-car-sharing:before {
  content: "\e271";
}

.icon-to-top-arrow:before {
  content: "\e272";
}

.icon-down-arrow:before {
  content: "\e273";
}

.icon-concierge:before {
  content: "\e274";
}

.icon-close-20:before {
  content: "\e275";
}

.icon-more-dots:before {
  content: var(--more-dots-icon, "\e276");
}

.icon-driver-coverage:before {
  content: "\e277";
}

.icon-vehicle-coverage:before {
  content: "\e278";
}

.icon-motorcycle-coverage:before {
  content: "\e279";
}

.icon-clock:before {
  content: "\e280";
}

.icon-inbound-email:before {
  content: "\e281";
}

.icon-outbound-email:before {
  content: "\e282";
}

.icon-inbound-message:before {
  content: "\e283";
}

.icon-outbound-message:before {
  content: "\e284";
}

.icon-alert-exclamation:before {
  content: "\e285";
}

.icon-total-loss:before {
  content: "\e286";
}

.icon-pin:before {
  content: "\e287";
}

.icon-plog:before {
  content: "\e288";
}

.icon-resize:before {
  content: "\e289";
}

.icon-web-accessibility:before {
  content: "\e290";
}

.icon-dashboard:before {
  content: "\e291";
}

.icon-travel:before {
  content: "\e292";
}

.icon-microphone:before {
  content: "\e293";
}

.icon-battery:before {
  content: "\e294";
}

.icon-camera:before {
  content: "\e295";
}

.icon-flat-tire:before {
  content: "\e296";
}

.icon-stuck-in-ditch:before {
  content: "\e297";
}

.icon-logout:before {
  content: "\e298";
}

.icon-send:before {
  content: "\e299";
}

.icon-return:before {
  content: "\e300";
}

.icon-cancel:before {
  content: "\e301";
}

.icon-wallet:before {
  content: "\e302";
}

.icon-lyft:before {
  content: "\e303";
}

.icon-microphone2:before {
  content: "\e304";
}

.icon-glassdoor:before {
  content: "\e305";
}

.icon-multiple-saved-quotes:before {
  content: "\e306";
}

.icon-bug:before {
  content: "\e307";
}

.icon-pdf:before {
  content: "\e308";
}

.icon-zip:before {
  content: "\e309";
}

.icon-pages:before {
  content: "\e310";
}

.icon-spotlight:before {
  content: "\e311";
}

.icon-versions:before {
  content: "\e312";
}

.icon-need-help:before {
  content: "\e313";
}

.icon-touch-id:before {
  content: "\e314";
}

.icon-professional-liability:before {
  content: "\e315";
}

.icon-general-liability:before {
  content: "\e316";
}

.icon-express:before {
  content: "\e317";
}

.icon-underwriter:before {
  content: "\e318";
}

.icon-property-card:before {
  content: "\e319";
}

.icon-workers-comp:before {
  content: "\e320";
}

.icon-extra-half:before {
  content: "\e321";
}

.icon-extra-empty:before {
  content: "\e322";
}

.icon-storage-plan-auto:before {
  content: "\e323";
}

.icon-storage-plan-cycle:before {
  content: "\e324";
}

.icon-flood:before {
  content: "\e325";
}

.icon-hail:before {
  content: "\e326";
}

.icon-hurricane:before {
  content: "\e327";
}

.icon-storm:before {
  content: "\e328";
}

.icon-tornado:before {
  content: "\e329";
}

.icon-fire:before {
  content: "\e330";
}

.icon-winter-storm:before {
  content: "\e331";
}

.icon-file-doc:before {
  content: "\e332";
}

.icon-file-img:before {
  content: "\e333";
}

.icon-severe-winter-storm:before {
  content: "\e334";
}

.icon-geico-cares:before {
  content: "\e335";
}

.icon-smile-face:before {
  content: "\e336";
}

.icon-straight-face:before {
  content: "\e337";
}

.icon-frown-face:before {
  content: "\e338";
}

.icon-parking-locator:before {
  content: "\e339";
}

.icon-trash:before {
  content: "\e340";
}

.icon-time-delay:before {
  content: "\e341";
}

.icon-travel-airplane:before {
  content: "\e342";
}

.icon-medical-bag:before {
  content: "\e343";
}

.icon-smart-speaker:before {
  content: "\e344";
}

.icon-drive-easy:before {
  content: "\e345";
}

.icon-wellness-fitness:before {
  content: "\e346";
}

.icon-landlord:before {
  content: "\e347";
}

.icon-community:before {
  content: "\e348";
}

.icon-pwc-boat:before {
  content: "\e349";
}

.icon-pontoon-boat:before {
  content: "\e350";
}

.icon-bass-boat:before {
  content: "\e351";
}

.icon-bowrider-boat:before {
  content: "\e352";
}

.icon-center-console-boat:before {
  content: "\e353";
}

.icon-cruiser-boat:before {
  content: "\e354";
}

.icon-walkaround-boat:before {
  content: "\e355";
}

.icon-cuddy-cabin-boat:before {
  content: "\e356";
}

.icon-sail-boat:before {
  content: "\e357";
}

.icon-virtual-assistant:before {
  content: "\e358";
}

.icon-add-renters:before {
  content: "\e359";
}

.icon-augmented-reality:before {
  content: "\e360";
}

.icon-arrow-left:before {
  content: "\e361";
}

.icon-arrow-right:before {
  content: "\e362";
}

.icon-bundling-auto-home:before {
  content: "\e363";
}

.icon-car-buying:before {
  content: "\e364";
}

.icon-commercial-delivery:before {
  content: "\e365";
}

.icon-discover:before {
  content: "\e366";
}

.icon-find-ride:before {
  content: "\e367";
}

.icon-explore:before {
  content: "\e368";
}

.icon-vehicle-care:before {
  content: "\e369";
}

.icon-cyber-liability:before {
  content: "\e370";
}

.icon-tiktok:before {
  content: "\e371";
}

.icon-live-chat:before {
  content: "\e372";
}

.icon-show:before {
  content: "\e373";
}

.icon-hide:before {
  content: "\e374";
}

.icon-earthquake:before {
  content: "\e375";
}

.icon-condo-fire:before {
  content: "\e376";
}

.icon-event:before {
  content: "\e377";
}

.icon-laptop:before {
  content: "\e378";
}

.icon-tablet:before {
  content: "\e379";
}

.icon-desktop:before {
  content: "\e380";
}

.icon-style:before {
  content: "\e381";
}

.icon-components:before {
  content: "\e382";
}

.icon-wifi:before {
  content: "\e383";
}

.icon-class-a-motorhome-rv:before {
  content: "\e384";
}

.icon-class-b-motorhome-rv:before {
  content: "\e385";
}

.icon-class-c-motorhome-rv:before {
  content: "\e386";
}

.icon-truck-camper-trailer-rv:before {
  content: "\e387";
}

.icon-recreational-cargo-trailer-rv:before {
  content: "\e388";
}

.icon-5th-wheel-trailer-rv:before {
  content: "\e389";
}

.icon-conventional-trailer-rv:before {
  content: "\e390";
}

.icon-pop-up-folding-trailer-rv:before {
  content: "\e391";
}

.icon-onboarding:before {
  content: "\e392";
}

.icon-learning:before {
  content: "\e393";
}

.icon-shopping:before {
  content: "\e394";
}

.icon-download:before {
  content: "\e395";
}

.icon-download-new-tab:before,
.icon-open-new-tab:before {
  content: "\e396";
}

.icon-play:before {
  content: "\e397";
}

.icon-pause:before {
  content: "\e398";
}

.icon-skip-next:before {
  content: "\e399";
}

.icon-skip-previous:before {
  content: "\e400";
}

.icon-bundling-auto-renters:before {
  content: "\e401";
}

.icon-bluetooth:before {
  content: "\e402";
}

.icon-motion:before {
  content: "\e403";
}

.icon-filter:before {
  content: "\e404";
}

.icon-power-on:before {
  content: "\e405";
}

.icon-power-off:before {
  content: "\e406";
}

.icon-thumbs-up:before {
  content: "\e407";
}

.icon-construction:before {
  content: "\e408";
}

.icon-celebration:before {
  content: "\e409";
}

.icon-translate:before {
  content: "\e410";
}

.icon-copy:before {
  content: "\e411";
}

.icon-web-component:before {
  content: "\e412";
}

.icon-react:before {
  content: "\e413";
}

.icon-muted-microphone:before {
  content: "\e414";
}

.icon-speaker:before {
  content: "\e415";
}

.icon-muted-speaker:before {
  content: "\e416";
}

.icon-flutter:before {
  content: "\e417";
}

.icon-sun:before {
  content: "\e418";
}

.icon-moon:before {
  content: "\e419";
}

.icon-auto-awesome:before {
  content: "\e420";
}

.icon-face:before {
  content: "\e421";
}

.icon-drag:before {
  content: " \e422 ";
}

.icon-time-and-date:before {
  content: "\e423";
}

.icon-clock-and-person:before {
  content: "\e424";
}

.icon-contact-attribute:before {
  content: "\e425";
}

.icon-engagement-path:before {
  content: "\e426";
}

.icon-connect:before {
  content: "\e427";
}

.icon-split:before {
  content: "\e428";
}

.icon-end:before {
  content: "\e429";
}

.icon-one-time:before,
.icon-route:before {
  content: "\e430";
}

.icon-recurring:before {
  content: "\e431";
}

.icon-lightning:before {
  content: "\e432";
}

.icon-archive:before {
  content: "\e433";
}

.icon-move:before {
  content: "\e434";
}

.icon-upload:before {
  content: "\e435";
}

.icon-thumbs-down:before {
  content: "\e436";
}

.icon-edit-text:before {
  content: "\e437";
}

.icon-stop:before {
  content: "\e438";
}
.icon-obd-device:before {
  content: "\e439";
}
.icon-stoplight:before {
  content: "\e440";
}
.icon-braking:before {
  content: "\e441";
}
.icon-battery-empty:before {
  content: "\e442";
}
.icon-battery-1:before {
  content: "\e443";
}
.icon-battery-2:before {
  content: "\e444";
}
.icon-battery-3:before {
  content: "\e445";
}
.icon-battery-4:before {
  content: "\e446";
}
.icon-battery-5:before {
  content: "\e447";
}
.icon-battery-6:before {
  content: "\e448";
}
.icon-battery-full:before {
  content: "\e449";
}
.icon-route-vertical:before {
  content: "\e450";
}
.icon-package:before {
  content: "\e451";
}
.icon-home:before {
  content: "\e452";
}
.icon-recenter:before {
  content: "\e453";
}
.icon-legend:before {
  content: "\e454";
}
.icon-tire:before {
  content: "\e455";
}
.icon-van:before {
  content: "\e456";
}
.icon-semi-truck:before {
  content: "\e457";
}
.icon-code:before {
  content: "\e458";
}
.icon-enterprise:before {
  content: "\e459";
}
.icon-commercial-business:before {
  content: "\e460";
}
.icon-chat-bubble:before {
  content: "\e461";
}
.icon-undo:before {
  content: "\e462";
}
.icon-redo:before {
  content: "\e463";
}
.icon-organize:before {
  content: "\e464";
}
.icon-utility-trailer-rv:before {
  content: "\e465";
}
.icon-brake-pedal:before {
  content: "\e466";
}
.icon-smooth-lines:before {
  content: "\e467";
}
.icon-distance:before {
  content: "\e468";
}
.icon-timer:before {
  content: "\e469";
}
.icon-laps:before {
  content: "\e470";
}
.icon-drive-easy-tm:before {
  content: "\e471";
}
.icon-dialpad:before {
  content: "\e472";
}
.icon-pattern:before {
  content: "\e473";
}
.icon-face-id:before {
  content: "\e474";
}
